/*
Wiki documentation for customising the menu: https://iqxusers.co.uk/iqxhelp/doku.php?id=iqxweb:technical:customize:menu
*/



function iqxWebBuildMenu(userClass){
  'use strict';

  function Menu(){
    this.items = []
  }

  Menu.prototype.addItem = function(options, position){
    var index

    if(typeof position !== 'undefined'){
      index = position
    }else{
      index = this.items.length
    }

    options.type = 'item'

    var newItem = new Item(options)
    this.items.splice(index, 0, newItem)
    return this
  }

  Menu.prototype.addLogoutButton = function(options, position){
    var index

    if(typeof position !== 'undefined'){
      index = position
    }else{
      index = this.items.length
    }

    options.type = 'logoutButton'

    var newItem = new Item(options)
    this.items.splice(index, 0, newItem)
    return this
  }

  Menu.prototype.addDropdown = function(options, position){
    var index

    if(typeof position !== 'undefined'){
      index = position
    }else{
      index = this.items.length
    }

    options.type = 'dropdown'

    var newItem = new Item(options)
    this.items.splice(index, 0, newItem)
    return newItem
  }

  Menu.prototype.addSplitter = function(options, position){
    var index

    if(typeof position !== 'undefined'){
      index = position
    }else{
      index = this.items.length
    }

    options.type = 'splitter'

    var newItem = new Item(options)
    this.items.splice(index, 0, newItem)
    return this
  }

  Menu.prototype.get = function(id){
    var arrayLength = this.items.length
    for (var i = 0; i < arrayLength; i++) {
      if(this.items[i].id === id){
        return this.items[i]
      }
    }
    throw new Error('Could not find any item in menu with id: '+id)
  }
  
  Menu.prototype.remove = function(id){
    var arrayLength = this.items.length
    for (var i = 0; i < arrayLength; i++) {
      if(this.items[i].id === id){
        return this.items.splice(i,1)[0]
      }
    }
    throw new Error('Could not find any item in menu with id: '+id)
  }

  //
  function Item(options){
    this.id = options.id
    this.type = options.type
    this.title = options.title
    this.icon = options.icon
    this.rights = options.rights
    this.switches = options.switches
    this.params = options.params
    this.url = options.url
    this.target = options.target
    this.subMenu = new Menu()
    this.subMenuExpanded = false
  }

  //// //// ////

  var menu = new Menu()

  if(userClass === 'candidate'){
    iqxWebBuildCandidateMenu(menu)
    window.iqxWebCustomCandidateMenu && iqxWebCustomCandidateMenu(menu)
  }else if(userClass === 'client'){
    iqxWebBuildClientMenu(menu)
    window.iqxWebCustomClientMenu && iqxWebCustomClientMenu(menu)
  }else if(userClass === 'agency'){
    iqxWebBuildAgencyMenu(menu)
    window.iqxWebCustomAgencyMenu && iqxWebCustomAgencyMenu(menu)
  }else if(userClass === 'owner'){
    iqxWebBuildOwnerMenu(menu)
    window.iqxWebCustomOwnerMenu && iqxWebCustomOwnerMenu(menu)
  }

  return menu

}
